import './SearchBar.scss'
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function SearchBar({ educationResourceItems = [], onSearch, type }) {
	const [filteredItems, setFilteredItems] = useState([]);
	const [inputValue, setInputValue] = useState("");
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const { t } = useTranslation();

	const suggestionsDropdownRef = useRef(null);

	const handleInputChange = (event, setInputValue, filteredItems, setIsDropdownOpen) => {
		const value = event.target.value;

		setInputValue(value);
		if (filteredItems.length > 0 && value.length > 1) setIsDropdownOpen(true);
	}

	const handleInputKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			handleSearch();
		}
	}

	const handleItemClick = (item) => {
		setInputValue(item);
		setIsDropdownOpen(false);
	};

	const handleSearch = () => {
		onSearch(inputValue);
	};

	useEffect(() => {
		const educationResourceItemsFiltered = educationResourceItems.filter((item) => {
			const descriptionMatch = item.description.toLowerCase().includes(inputValue.toLowerCase());
			const titleMatch = item.title.toLowerCase().includes(inputValue.toLowerCase());

			return descriptionMatch || titleMatch;
		});

		setFilteredItems(educationResourceItemsFiltered);
		setIsDropdownOpen(educationResourceItems.length > 0 && inputValue.length > 1);
	}, [inputValue, educationResourceItems]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (suggestionsDropdownRef.current && !suggestionsDropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<div className="search-bar-container" ref={suggestionsDropdownRef}>
			<div className="search-bar-input">
				<input
					type="text"
					placeholder={`${t('search')} ${type}`}
					onChange={(event) => {
						handleInputChange(event, setInputValue, filteredItems, setIsDropdownOpen)
					}}
					onKeyDown={(event) => {
						handleInputKeyDown(event)
					}}
					value={inputValue}
				/>

				<div className="search-bar_icon-magnifying-glass">
					<span onClick={handleSearch}></span>
				</div>
			</div>
			{isDropdownOpen && (
				<ul className="search-bar_dropdown-suggestions">
					<span className="search-bar_dropdown-suggestions-title">{t('suggestions')}</span>
					{filteredItems.length === 0 ? (
						<div className='search-bar_dropdown-there-are-no-results'>
							<span>{t('there-are-no-results')}</span>
						</div> ):(
						<>
							{filteredItems.map((item, index) => (
								<li
									className="list-group-item-action"
									key={index}
									onClick={() => {
										handleSearch();
										handleItemClick(item.title);
									}}
								>
									<div>
										<span>{item.title}</span>
										<p>{item.description}</p>
									</div>
								</li>
							))}
						</>
					)}
				</ul>
			)}
		</div>
	);
}

export default SearchBar;
